import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  customerName: ''
};

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomerName: (state, action) => {
      state.customerName = action.payload;
    }
  }
});

export const { setCustomerName } = customerSlice.actions;

export default customerSlice.reducer;
